import React, { useEffect, useCallback, useState, useRef, useMemo } from "react";
import { AppStoreApplication, RecommendedType, TopType } from "@/services/AppStore";
import { useTranslation } from "react-i18next";
import ToolsItem from "./ToolsItem/index";
import { isBjme } from "@/utils";
import { thirdApp } from "@/assets/img";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import Bus from "@/utils/bus";
import { changeEgovUrl } from "@/utils/tools";
import { MinusCircleFilled } from "@/utils/antdIcon";
import { ICard } from "../../interface";

// 设置样式
/* eslint max-params: ["error", 4] */
const getItemStyle = (isDragging: any, draggableStyle: any) => ({
  // some basic styles to make the items look a bit nicer
  userSelect: "none",
  boxShadow: isDragging ? " 0 1px 9px 0 rgba(198,198,198,0.5)" : "",
  position: "relative",
  cursor: "move",
  ...draggableStyle
});

export default function DragContent({
  rightContentList,
  onReorder,
  onDeleteCard
}: {
  rightContentList: ICard[];
  onReorder: (startIndex: any, endIndex: any) => void;
  onDeleteCard?: (card: any) => void;
}) {
  const [loading, _setLoading] = useState(false);
  const [isDragging, setDragging] = useState(false);
  const scrollRef: any = useRef(null);

  const removeCard = useCallback(
    (item: any) => {
      onDeleteCard?.(item);
    },
    [onDeleteCard]
  );

  // 设置loading及appKey
  const setLoading = useCallback((parames) => {
    const { loading = false, applicationId = "" } = parames;
    _setLoading(loading);
  }, []);

  useEffect(() => {
    Bus.on("setLoading", setLoading);
    return () => {
      Bus.off("setLoading", setLoading);
    };
  }, [setLoading]);

  const { t } = useTranslation("common");
  const onDragEnd = (result: any) => {
    setDragging(false);
    if (!result.destination) {
      return;
    }
    // console.log("this is ondrageend", result);
    onReorder(result.source.index, result.destination.index);
  };
  return (
    <div className="right-tools-content">
      <DragDropContext
        onDragEnd={onDragEnd}
        onBeforeDragStart={() => {
          setDragging(true);
        }}
      >
        <div>
          <Droppable droppableId="list">
            {(provided, snapshot) => (
              <div {...provided.droppableProps} ref={provided.innerRef}>
                {rightContentList?.map((item: ICard, index: number) => {
                  return (
                    <Draggable key={item.cardId} draggableId={item.cardId} index={index}>
                      {(provided, snapshot) => (
                        <div
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          style={getItemStyle(snapshot.isDragging, provided.draggableProps.style)}
                          className="modal_card_tool_circular"
                        >
                          <ToolsItem
                            isDragging={true}
                            toolsItem={item}
                            loading={loading}
                            isShowDragIcon={true}
                            handleBtn={
                              item.deletable ? (
                                <MinusCircleFilled
                                  style={{ color: "#F25448" }}
                                  onClick={() => removeCard(item)}
                                />
                              ) : (
                                <MinusCircleFilled
                                  style={{ color: "#E6E6E6", cursor: "not-allowed" }}
                                />
                              )
                            }
                          />
                        </div>
                      )}
                    </Draggable>
                  );
                })}
                {/* {JSON.stringify(snapshot)} */}
                {/* 解决组件react-beautiful-dnd滚动底部出现抖动问题 */}
                {isDragging && (
                  <div
                    style={{
                      width: "100%",
                      height: "79px"
                    }}
                  />
                )}
              </div>
            )}
          </Droppable>
        </div>
      </DragDropContext>
    </div>
  );
}
